<script>
  //   import { black, gray, yellow } from "../utils/colors";
  let gray = "#333533";
  let black = "#242423";
  let yellow = "#F5CB5C";
  let white = "#F4F6F3";
  let blue = "#D0DCD6";
  export let timeline;
  export let title;
  export let description;
  export let place;
</script>

<main
  class="md:max-w-[450px] bg-[#333533] p-8 space-y-1 rounded-md my-6 text-sm"
>
  <h1>📅 {timeline}</h1>
  <p class="text-xl text-[#f5cb5c] font-semibold">
    {title}
  </p>
  <p>
    {description}
  </p>
  <p class="text-blue-300">{place}</p>
</main>
